import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import getDefaultBlockInfo from './defaultBlockInfo';

// import utils from '../../../utils/utils';

export function updateItemInItems(items, itemId, payload) {
  for (let itemIndex = 0; itemIndex < items.length; itemIndex += 1) {
    const item = items[itemIndex];
    if (item._id === itemId) {
      items[itemIndex] = {
        ...item,
        ...payload
      };
      return true;
    }

    const isUpdated = updateItemInItems(item.items || [], itemId, payload);
    if (isUpdated) {
      return true;
    }
  }

  return false;
}

export function removeBlockItem(items, itemId) {
  for (let itemIndex = 0; itemIndex < items.length; itemIndex += 1) {
    const item = items[itemIndex];
    if (item._id === itemId) {
      items.splice(itemIndex, 1);
      return true;
    }
  }

  return false;
}

export const moveArrayElem = (array, oldIndex, newIndex) => {
  if (newIndex >= array.length) {
    let k = newIndex - array.length;
    while (k-- + 1) {
      array.push(undefined);
    }
  }
  array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
  return array;
};

export const moveBlock = (oldIndex, newIndex, dispatch) => () => {
  dispatch('MOVE_BLOCK', null, { oldIndex, newIndex });
};

// console.log(getDefaultBlockInfo(`${type}-${family}-${variant}`));
const defaultBlockInfo = (type, family, variant) => getDefaultBlockInfo(`${type}-${family}-${variant}`);
export const insertNewBlock = (lesson, insertBlockIndex, type, family, variant) => {
  const newBlocks = cloneDeep(lesson.content.blockInfo);
  newBlocks.splice(insertBlockIndex, 0, defaultBlockInfo(type, family, variant));
  lesson.content.blockInfo = cloneDeep(newBlocks);
  return lesson;
};

export const gettingStartedBlock = () => (
  <div className="block__container">
    <div className="block__side" />
    <div className="block__main">
      <div className="block__helper">
        <h2 className="block__helper-title">Getting started</h2>
        <p className="block__helper-text">
          Hover below this help text and click the plus icon to add your first block.
        </p>
      </div>
    </div>
  </div>
);

const findAndInsertBlockKey = (blockPerformance, blocks) => {
  blocks.forEach((block) => {
    if (!blockPerformance[block.pid]) {
      blockPerformance[block.pid] = {};
    }
  });
};

export const initOrModifyBP = (blockPerformance, blocks) => {
  blocks.forEach((block) => {
    if (!blockPerformance[block.pid]) {
      blockPerformance[block.pid] = {};
    }
  });
  /* if (Object.keys(blockPerformance).length !== blocks.length) {
    findAndInsertBlockKey(blockPerformance, blocks);
  } */
  return blockPerformance;
};
